import type { TeamMember } from 'features/TeamChat/api/teamChat.types'

export type OpenToken = { start: number; query: string }
export type Edit = { text: string; caret: number }
export type HelpPlan = { title: string; clearDraft: boolean }

const TOKEN_BEFORE_CARET = /(^|\s)@(\w*)$/
const MENTION = /@\w+/g

export const HELP_TEXT = 'I need help'

// The "@name" being typed right before the caret, if any.
export const openToken = (text: string, caret: number): OpenToken | null => {
  const match = TOKEN_BEFORE_CARET.exec(text.slice(0, caret))
  if (!match) return null
  return { start: caret - match[2].length - 1, query: match[2] }
}

// Teammates (never me) whose handle starts with what was typed after "@".
export const matchMembers = (members: TeamMember[], query: string): TeamMember[] =>
  members.filter((m) => !m.is_me && m.handle.toLowerCase().startsWith(query.toLowerCase()))

// Completes the "@name" being typed, or adds the mention at the caret with a space before it.
export const insertHandle = (text: string, caret: number, handle: string): Edit => {
  const mention = `@${handle} `
  const token = openToken(text, caret)
  const start = token ? token.start : caret
  const gap = !token && start > 0 && !/\s$/.test(text.slice(0, start)) ? ' ' : ''
  const before = text.slice(0, start) + gap + mention
  return { text: before + text.slice(caret), caret: before.length }
}

// A draft of only mentions asks those people for help; any other draft stays and help goes to the team.
export const helpPlan = (draft: string): HelpPlan => {
  const onlyMentions = draft.replace(MENTION, '').trim() === ''
  if (!onlyMentions) return { title: HELP_TEXT, clearDraft: false }
  return { title: `${draft.trim()} ${HELP_TEXT}`.trim(), clearDraft: true }
}
